export default __webpack_public_path__ + "static/media/users.1b4660c7.svg";